import Vue from 'vue'
import Vuex from 'vuex'

import data from './data'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentView: 'landing',
    animating: false,
    scrollDirection: 'down',
    ...data,
    selectedPostcode: null,
    hoverPostcode: null
  },
  mutations: {
    update_view (state, payload) {
      state.currentView = payload
    },
    update_animating (state, payload) {
      state.animating = payload
    },
    update_scrollDirection (state, payload) {
      state.scrollDirection = payload
    },
    update_selected_postcode (state, payload) {
      if (
        state.selectedPostcode && state.selectedPostcode.postcode
        && payload && payload.postcode
        && state.selectedPostcode.postcode === payload.postcode
      ) {
        return state.selectedPostcode = null
      } 
      state.selectedPostcode = payload
    },
    update_hover_postcode (state, payload) {
      state.hoverPostcode = payload
    }
  },
  getters: {
    highlightedPostcode (state) {
      if (state.selectedPostcode) return state.selectedPostcode
      if (state.hoverPostcode)    return state.hoverPostcode
      return null
    }
  }
})

